






















import Vue from 'vue';
import { IPreviewBlogPost } from '@/common/interfaces/ringana-blog.interfaces';
import AppHelper from '@/helpers/AppHelper';

interface IProductListDisruptorComponent {
  AppHelper: typeof AppHelper;
}

export default Vue.extend({
  name: `ProductListDisruptor`,
  data(): IProductListDisruptorComponent {
    return {
      AppHelper,
    };
  },
  props: {
    disruptor: {
      required: true,
      type: Object as () => IPreviewBlogPost,
    },
    hasMultipleCarts: {
      required: true,
      type: Boolean,
    },
  },
});
